// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"u1W_aGDW","favicon":"lZP49oN1","content":"qVhnlYA5","onlyUrl":"RDVMgx6K","infoWrapper":"oyi761rO","title":"k5sRrgEY","url":"dUjZqIo4","dragHandle":"glG6ptAZ"};